import AddLogbookDynamicFormProperties from "src/pages/Setup/LogbookDynamicFormProperties/AddLogbookDynamicFormProperties";

export const logBookDynamicFormPropertiesSetupRoutes = [
  { path: '/setup/logbook-dynamic-form', component: AddLogbookDynamicFormProperties },  
];
